import React from "react";
import { Redirect } from "react-router-dom";
import i18next from "i18next";

import fr_CA from "./i18n/fr_CA";
import en_CA from "./i18n/en_CA";

i18next.addResourceBundle("fr-CA", "dispatchApp", fr_CA);
i18next.addResourceBundle("en-CA", "dispatchApp", en_CA);

export const DispatchConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  name: "Dispatch",
  auth: "dispatch_management",
  routes: [
    {
      path: "/app/dispatch/list",
      component: React.lazy(() => import("./views/List")),
    },
    {
      path: "/app/dispatch/add",
      component: React.lazy(() => import("./views/Add")),
    },
    {
      path: "/app/dispatch/edit/:itemId",
      component: React.lazy(() => import("./views/Edit")),
    },
    {
      path: "/app/dispatch/view/:itemId",
      component: React.lazy(() => import("./views/View")),
    },
    {
      path: "/app/dispatch",
      component: () => <Redirect to="/app/dispatch/list" />,
    },
  ],
}; 